
@if(this.router.url.length > 1 && this.router.url != "/support") {
  <div class="d-inline-flex gap-3 justify-content-center align-items-center">
    <a (click)="goToCrumb(['/'], 0)" class="crumb home">
      <i class="bi bi-house-door-fill homeIcon"></i>
<!--      <span>{{translations.home}}</span>-->
    </a>
    @for (path of router.url.split('/').filter(Boolean); track path; let i = $index) {
      @if(path.length) {
        <div class="d-inline-flex gap-3 justify-content-center align-items-center">
          <i class="bi bi-caret-right-fill caret-width"></i>
          @if(i < router.url.split('/').filter(Boolean).length - 1){
            <a
              (click)="goToCrumb(router.url.split('/').filter(Boolean), i)"
              class="crumb">{{translations[path]}}
            </a>
          } @else {
            <span class="currentPath">{{translations[path]}}</span>
          }
        </div>
      }
    }
  </div>
}
